import React from "react";
import AsyncSelect from "react-select/async";
import debounce from "debounce-promise";
import _ from "lodash";
import httpClient from "/components/utils/httpClient";

const ceCustomSelectStyles = {
  container: (base) => ({
    ...base,
    margin: "0px 0 20px",
  }),
  control: (base, state) => ({
    ...base,
    height: 40,
    border: "1px solid #DEE7EE",
    margin: 0,
    borderRadius: 8,
    boxShadow: state.isFocused || state.isSelected ? "0 0 0 2px #7034e0" : "0px 0px 3px 0px rgba(0,0,0,0.035)",
    "&:hover": {
      border: "1px solid #DEE7EE",
      cursor: "text",
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 12px",
    margin: 0,
  }),
  placeholder: (base) => ({
    ...base,
    fontSize: 14,
    color: "#718291",
    fontWeight: "400",
  }),
  input: (base) => ({
    ...base,
    padding: 0,
    margin: 0,
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
};

const CorporationSelect = (props) => {
  const loadOptions = (query) => fetchSearchTerm(query);

  const debouncedLoadOptions = debounce(loadOptions, 800, {
    leading: true,
  });

  const formatOptionLabel = (option) => {
    return (
      <span className="t__stack">
        <div className="t__stack__title">{option.value} - {option.label}</div>
        <div className="t__stack__subtitle">{option.address}</div>
      </span>
    );
  };

  const fetchSearchTerm = async (query) => {
    const results = await httpClient
      .get("/api/corporations", { params: { query } })
      .then((response) => {
        return _.reject(response.data, (c) => props.exclusions?.includes(c.entity_identifier)).map((c) => {
          return { value: c.entity_identifier, label: c.name, address: c.address };
        });
      })
      .catch((error) => console.error("Error:", error));

    return results;
  };

  const onSelectChange = (val) => {
    if (val === null) {
      props.onChange("");
    } else {
      const newValue = (props.value || []).filter((d) => d.value != val[0].value).concat(val);
      props.onChange(newValue);
    }
  };

  return (
    <AsyncSelect
      isMulti={props.isMulti}
      name="corporation_identifier"
      placeholder={"Search by Dispensing Entity Name"}
      value={props.showValue ? props.value : ""}
      openMenuOnFocus={false}
      openMenuOnClick={false}
      styles={ceCustomSelectStyles}
      defaultOptions={false}
      isClearable={props.isClearable}
      onChange={onSelectChange}
      loadOptions={(query) => debouncedLoadOptions(query)}
      components={{ DropdownIndicator: null, IndicatorSeparator: null }}
      inputRef={props.inputRef}
      formatOptionLabel={(option) => {
        return formatOptionLabel(option);
      }}
    />
  );
};

export default CorporationSelect;
